{
    "ReportlistMyreportlist": "Mijn rapportlijst",
    "ReportlistAddreport": "Rapport toevoegen",
    "ReportlistDeletereport": "Rapport verwijderen",
    "ReportlistMoreoptions": "Afdrukuitvoeropties",
    "ReportlistModifyreport": "Rapport wijzigen",
    "ReportlistCopyreport": "Rapport kopiëren",
    "ReportlistRenamefolder": "Naam map wijzigen",
    "ReportlistRenamereport": "Naam rapport wijzigen",
    "NoreportsconfiguredText": "Geen rapporten geconfigureerd.",
    "ReportlistRecyclebin": "Prullenbak",
    "ReportlistEmptyrecyclebin": "Lege prullenbak",
    "ReportlistRestoreallreports": "Alle rapporten herstellen",
    "ReportlistRestorereport": "Rapport herstellen",
    "ReportlistDeletereportsinfolder": "Mapinhoud verwijderen",
    "ReportlistRestorereportsinfolder": "Inhoudsbeperking",
    "ReportlistNotAllCompleted": "{} van {} geselecteerde rapporten zijn naar de prullenbak verplaatst.",
    "ReportlistOutof": "uit",
    "ReportlistNoreportswererestored": "Er zijn geen meldingen hersteld.",
    "ReportlistReportwasrestored": "Rapport is hersteld.",
    "ReportlistReportswererestored": "{} rapporten zijn hersteld.",
    "ReportlistXoutofyselectedreportswererestored": "{} van {} geselecteerde rapporten zijn hersteld.",
    "ReportlistRestoregenericfailurereason": "De mislukte rapporten zijn mogelijk al hersteld of permanent verwijderd.",
    "ReportlistNoreportsweremovedtobin": "Er zijn geen rapporten naar de prullenbak verplaatst.",
    "ReportlistReportwasmovedtobin": "Rapport is verplaatst naar prullenbak.",
    "ReportlistReportsweremovedtobin": "{} rapporten zijn naar de prullenbak verplaatst.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} van {} geselecteerde rapporten zijn naar de prullenbak verplaatst.",
    "ReportlistMovetobingenericfailurereason": "De mislukte rapporten zijn mogelijk al naar de prullenbak verplaatst.",
    "ReportlistThirtydaysremaining": "Dit blijft 30 dagen in je prullenbak of totdat het wordt geleegd.",
    "ReportlistBeendeleted": "is verwijderd.",
    "ReportlistNoreportsweredeletedpermanently": "Er zijn geen rapporten permanent verwijderd.",
    "ReportlistReportwasdeletedpermanently": "Rapport is definitief verwijderd.",
    "ReportlistReportsweredeletedpermanently": "{} rapporten zijn definitief verwijderd.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "[|1 |2 van |3 geselecteerd]",
    "ReportlistDeletepermanentlygenericfailurereason": "De mislukte rapporten zijn mogelijk al permanent verwijderd of hersteld en bevinden zich niet meer in de prullenbak.",
    "ReportlistMoveToBinCondition": "Laat me dit dialoogvenster in de toekomst niet meer zien.",
    "ReportlistNoreportswerecopied": "Er zijn geen rapporten gekopieerd.",
    "ReportlistReportwascopied": "Rapport is gekopieerd.",
    "ReportlistReportswerecopied": "{} rapporten zijn gekopieerd.",
    "ReportlistXoutofyselectedreportswerecopied": "{} van {} geselecteerde rapporten zijn gekopieerd.",
    "ReportlistCopygenericfailurereason": "De mislukte rapporten zijn mogelijk al naar de prullenbak verplaatst.",
    "NAME": "LanguageMyReportList",
    "ReportlistAdddefaultreport": "Standaardrapport toevoegen",
    "ReportListCopyReportsSuccessfulMessage": "{} rapport(en) succesvol gekopieerd",
    "ReportlistOverrideExistingReport": "Vink aan als je je bestaande rapporten wilt overschrijven.",
    "ReportlistReportsKeptForThirtyDays": "Overtroffen rapporten worden 30 dagen in de prullenbak bewaard of totdat ze worden geleegd."
}